// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowListModal-cls1_W_d","cls2":"BulkFollowListModal-cls2_X9A BulkFollowListModal-cls1_W_d"};